import { fetchPost, objectify, objectifyAddress, fetchGet } from '../utils'

export const search = (query) => {
  const { SearchText, Sort, BatchPage, Filters } = query
  const respType = 'Inline'


  let filters = {};
    if (Filters) {
        filters = {
            ...Filters,
            Status: Filters.Status === '0' ? '' : Filters.Status,
            Finalised: Filters.Finalised === '0' ? '' : Filters.Finalised,
            Supplier: Filters?.Supplier ? parseInt(Filters?.Supplier) : undefined
        };
    }

  return fetchPost('/PurchaseOrderEnquiry/Search', { SearchText, BatchPage,  ...(filters ?? {}) }, null, respType)
    .then((result) => (result && result.PurchaseOrders &&
      {
        PurchaseOrders: result.PurchaseOrders.map((val) => objectify(val)),
        currPage: result.BatchInformation && result.BatchInformation.BatchPage,
        nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
        prevPage: result.BatchInformation && result.BatchInformation.BatchPage > 1
      }
    ) || {PurchaseOrders: []})
}

export const searchById = (PurchaseOrder) => {
  return fetchGet(`PurchaseOrderEnquiry/PurchaseOrder/${PurchaseOrder}/Summary`, null, 'Inline')
    .then((result) => ({
      PurchaseOrders: (result
        && result.PurchaseOrderSummary
        && [ objectify(result.PurchaseOrderSummary) ])
        || [],
      currPage: 1,
      nextPage: false,
      prevPage: false}))
}

export const fetchSummary = (query) => {
  const { PurchaseOrder } = query
  return fetchGet(`PurchaseOrderEnquiry/PurchaseOrder/${PurchaseOrder}/Summary`)
    .then((result) => result ? objectify(result.PurchaseOrderSummary) : null)
}

export const getDetails = (query) => {
  const { PurchaseOrder } = query
  return fetchGet(`/PurchaseOrderEnquiry/PurchaseOrder/${PurchaseOrder}/Details`, null, 'Inline')
    .then((result) => {
      if (result) {
        const purchaseOrderDetails = objectify(result.PurchaseOrderDetails)
        return {
          values: Object.assign(purchaseOrderDetails, {
            SupplierAddress: objectifyAddress(purchaseOrderDetails, 'Supplier'),
            DeliveryAddress: objectifyAddress(purchaseOrderDetails, 'Delivery')
          }), schema: result.PurchaseOrderDetails
        }
      } else {
        return null
      }
    })
}
